import { localeNumberWithFixed } from "psims/lib/formatters/numbers";
import { INVALID_ENTITY_NAME_TEXT } from "psims/constants/validation-messages";
import { StorageValidationResult } from "./mso-stockholding-storages-validation";

export function getStorageInlineMessage(validationResult: StorageValidationResult | null): string | undefined {
  if (validationResult == null) {
    return undefined;
  }

  switch (validationResult.code) {
    case 'invalid_required':
      return 'A value is required for this field';

    case 'character_limit':
      return `Must be ${localeNumberWithFixed(validationResult.limit)} characters or fewer`;

    case 'invalid_characters':
      return INVALID_ENTITY_NAME_TEXT;

    case 'inactive_product':
      return undefined;
    case 'invalid_decimal':
    return `Please enter a number with up to ${validationResult.decimalPlaces} decimal places`;
  }
}